import { Theme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";

import createStyles from "@mui/styles/createStyles";

const peersStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            marginBottom: theme.spacing(4),
        },

        chipsContainer: {
            backgroundColor: theme.palette.background.grey,
            borderRadius: theme.spacing(1.25),
            padding: theme.spacing(1.5),
        },

        peerItem: {
            marginBottom: theme.spacing(0.5),
            fontSize: 16,
            fontWeight: 400,
            color: theme.palette.primary.main,
        },

        peerItemIcon: {
            color: theme.palette.primary.dark,
            fontSize: 16,
            marginRight: theme.spacing(0.5),
            marginTop: theme.spacing(0.5),
        },
        proContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
        },
        noPeersTextContainer: {
            backgroundColor: theme.palette.background.grey,
            borderRadius: theme.spacing(1.25),
            padding: theme.spacing(1.5),
            textAlign: "center",
        },
    })
);

export default peersStyles;
